import React, { useEffect, useState ,useRef} from "react"
import add from "../images/add.png"
import { Link, Routes,NavLink, Route, Outlet, useNavigate } from "react-router-dom"
import { useLocation } from 'react-router-dom'
import axios from 'axios';
import "../styles/EachShop.css"
import VerifiedIcon from '@mui/icons-material/Verified';
import { CircularProgress, IconButton, Rating } from "@mui/material";
import {Button} from "@mui/material";
import TextArea from 'antd/es/input/TextArea';
import EditIcon from '@mui/icons-material/Edit';
import RateReviewIcon from '@mui/icons-material/RateReview';
import CloseIcon from '@mui/icons-material/Close';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import ChatIcon from '@mui/icons-material/Chat';
import {motion} from 'framer-motion'


export default function EachShop({propsData}){

    const location = useLocation()
    const [routes,setRoutes]=useState(location.pathname.split("/"))
  //  console.log(routes[2]);
    let [shop,GetShop]=useState({})

    let navigate=useNavigate()
    useEffect(()=>{
            axios.get(`${process.env.REACT_APP_URL}/api/shope/getEachShope/${routes[2]}`, //proxy uri
            {
               headers: {
                  authorization:`Bearer ${ propsData.userData?.token }`,
                  'Content-Type': 'application/json'
               } 
            })
            .then(res=>{
             // console.log(res.data);
              GetShop(res.data)
            })
            .catch(error=>{
              console.log(error);
              if(error?.response?.data?.error==="shope not found"){
                navigate("/profile/shop")
              }

            })
      },[propsData.equilizer])
      
   //   //console.log(shop);

    const [active, setActive] = useState([-1]);
    const [EachShopArray,HandleEachShopArray] =useState([
        {
            id: "",
            name: "Posts"
        }, 
        {
            id: "subscriber",
            name: "Subscribers"
        }, 
        {
            id: "admins",
            name: "Admins"
        }, 
        {
            id: "categories",
            name: "Categories"
        }, 
        {
            id: "setting",
            name: "Settings"
        }
    ]);
    
    useEffect(()=>{
       // console.log(shop?.ownedBy?._id?.toString(),propsData.userData?.data?._id?.toString());
       if(shop&&shop?.ownedBy?._id?.toString()!==propsData.userData?.data?._id?.toString()){
        HandleEachShopArray([
            {
                id: "",
                name: "Posts"
            }, 
            {
                id: "subscriber",
                name: "Subscribers"
            }, 
            {
                id: "categories",
                name: "Categories"
            },
        ])
       }
       else{
        HandleEachShopArray([
            {
                id: "",
                name: "Posts"
            }, 
            {
                id: "subscriber",
                name: "Subscribers"
            }, 
            {
                id: "admins",
                name: "Admins"
            }, 
            {
                id: "categories",
                name: "Categories"
            }, 
            {
                id: "setting",
                name: "Settings"
            }
        ])
       }

    },[shop,location])

    let [post,setAddPost]=useState([])

    const [isFixed, setIsFixed] = useState(false);

    useEffect(() => {
      const handleScroll = () => {
        const scrollY = window.scrollY || window.pageYOffset;
        setIsFixed(scrollY >= 200);
      };
  
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    
    let [load_subscribe,handle_load_subscribe]=useState(false)
   
    const subscribeShop=()=>{
        let value={
            hostShopId:routes[2],
            remoteShopId:propsData.currentShope,
        }
        handle_load_subscribe(true)
        axios.put(`${process.env.REACT_APP_URL}/api/shope/ManageSubscribe`,value, //proxy uri
        {
           headers: {
              authorization:`Bearer ${ propsData.userData?.token }`,
              'Content-Type': 'application/json'
           } 
        })
        .then(res=>{
          console.log(res.data);
          handle_load_subscribe(false)
          propsData.setEquilizer(propsData.equilizer+3)
        })
        .catch(error=>{
          handle_load_subscribe(false)
          console.log(error);
        })

    }

    let checkSubscribtion=shop?.Subscirbers?.filter(e=>{
        return e?._id?.toString()===propsData.currentShope
    })

    let [AllReviews,GetAllReviews]=useState([])
    let [AveregaRate,GetAveregaRate]=useState(0)
    let [LoadReview,HandleLoadReview]=useState(false)
    
    useEffect(()=>{
      HandleLoadReview(true)
      axios.get(`${process.env.REACT_APP_URL}/api/shope/GetShopeReviews/${routes[2]}`, //proxy uri
      {
         headers: {
            authorization:`Bearer ${ propsData.userData?.token }`,
            'Content-Type': 'application/json'
         } 
      })

      .then(res=>{
        //console.log(res.data);
        HandleLoadReview(false)
        GetAllReviews(res.data.reviews)
        GetAveregaRate(res.data.rate||0)
        if(res.data.length>20){
            GetAllReviews(res.data.reviews.slice(0,30))
        }
      })
      .catch(error=>{
         //console.log(error);
      })
    },[propsData.equilizer])


    let [loading,setLoading]=useState(false)
    let [error,GetError]=useState(false)
    const [reviewText,handleReviewText]=useState("")
    const [reviewRate,handleReviewRate]=useState(0)

    const AddReviews=()=>{
        setLoading(true)
        if(reviewRate===null){
            return;
        }
        let value={
            reviewer:propsData.currentShope,
            shopId:routes[2],
            text:reviewText,
            rate:reviewRate,
        }  

        axios.put(`${process.env.REACT_APP_URL}/api/shope/AddReviews`,value, //proxy uri
        {
           headers: {
              authorization:`Bearer ${ propsData.userData?.token }`,
              'Content-Type': 'application/json'
           } 
        })
        .then(res=>{
          ////console.log(res.data);
          setLoading(false)
          handleReviewRate("")
          handleReviewText("")
          propsData.setEquilizer(propsData.equilizer+3)
        })
        .catch(error=>{
            setLoading(false)
            GetError("Try, again later")
            setTimeout(()=>{
                GetError("") 
            },3000)

          console.log(error);
        })
    }

     let userAlreadyeviewd=AllReviews?.filter(e=>{
        return e?.By?._id?.toString()===propsData.currentShope
     })

     let [seeDetailsPage,GetSeeDetailsPage]=useState(false)
     let [showAddReview,handleShowAddReview]=useState(false)

     let [loadingCreateChat,GetLoadingCreateChat]=useState(false)
     let [errorCreateChat,GetErrorCreateChat]=useState(false)
   
     const creatChatAndRedirect=()=>{
       let datas={
        shopIds:[propsData.currentShope,routes[2]],
        name:"individual",
       }
  
       GetLoadingCreateChat(true)
       GetErrorCreateChat(false)
      axios.post(`${process.env.REACT_APP_URL}/api/chats/CreatChat/`,datas, //proxy uri
      {
         headers: {
            authorization:`Bearer ${ propsData.userData?.token }`,
            'Content-Type': 'application/json'
         } 
      })
      .then(res=>{
        GetLoadingCreateChat(false)
        GetErrorCreateChat(false)
        propsData.setEquilizer(propsData.equilizer+3)
        navigate(`/chat/${res.data._id}`)
      })
      .catch(error=>{
        GetLoadingCreateChat(false)
        GetErrorCreateChat(true)
        console.log(error);
      })
  
  
    }

//leave the shop
   let[leavePage,setLeavePage]=useState(false)
   let[isLeaving,setIsLeaving]=useState(false)
   let[errorLeaving,setErrorLeaving]=useState(false)

   const LeaveShop=()=>{
    setIsLeaving(true)
    let values={
      shopId:shop?._id,
    }
    axios.put(`${process.env.REACT_APP_URL}/api/shope/LeaveShop`,values, //proxy uri
    {
       headers: {
                  authorization:`Bearer ${ propsData.userData?.token }`,
                  'Content-Type': 'application/json'
             } 
    })
    .then(res=>{
        if(propsData.userShope.length>0){
            propsData.handleCurrentShope(propsData.userShope[0])
            console.log(propsData.userShope[0]);
        }
        
        setIsLeaving(false)
        propsData.setEquilizer(propsData.equilizer+2)
        window.location.href = "/profile/shop"
    })
    .catch(error=>{
      console.log(error);
      setIsLeaving(false)
      setErrorLeaving(error?.response?.data?.error||"Error Occured, please try again")
      setTimeout(()=>{
        setErrorLeaving("")
      },5000)
    })
   }

   let amContributor=shop?.ownedBy?._id!==propsData?.userData?.data?._id?.toString()
   //console.log(shop.ownedBy?._id,propsData?.userData?.data?._id?.toString())
 //  console.log(shop);
   return (
        <div >

           <div className="each-shop-top-container">
               <div className="each-shop-top">
                        <div><img className="each-shop-top-profile-picture" src={shop?.coverPic?.fileUrl||'/default-JB-FE-Shop_10.png'} /></div>
                        <Link style={{textDecoration:"none",color:"inherit"}} to={`/shop/${shop._id}`}>
                                <div className="each-shop-top-name_location">
                                        <div className="each-shop-top-name">{shop?.shope_name}</div>
                                        <div className="each-shop-top-location"><AddLocationAltIcon style={{fontSize:"12px",color:"red"}}/> {shop?.country}</div>
                            </div>
                        </Link>
                        <div className="each-shop-top-status">{!shop?.isOpened&&<img src="/closed-shope-dfdgf-435.png" alt="shope closed"/>}</div>
                        <div  className="each-shop-top-verification">{shop?.isVerified&&<VerifiedIcon style={{color:"green"}}/>}</div>
                
                        <div className="each-shop-top-subscribe_rating">
                            <div className="each-shop-top-subscribe">
                                    {propsData.currentShope!==routes[2]&&<div className="each-shop-top-subscribe-button"><Button onClick={subscribeShop}>{checkSubscribtion?.length>0?"Unsubscribe":"Subscribe"}</Button></div>}
                                    <div className="each-shop-top-subscribe-Data">{shop?.Subscirbers?.length} Subscribers</div>
                            </div>
                            <div className="each-shop-top-rating">
                                <div style={{fontSize:"20px",fontWeight:700}}> {Math.round(AveregaRate * 10)/10} </div>
                                <div><Rating name="half-rating-read" value={Math.round(AveregaRate * 10)/10} precision={0.5} readOnly /></div>
                            </div>

                        </div>
                </div>

                 <div className="each-shop-top-subscribe-reviews">
                      <div  className="each-shop-top-subscribe-reviewsAll">
                             
                             {AllReviews?.map(e=>{
                                 if(!e?.By?._id){
                                    return
                                }
                                return(
                                    <div  className="each-shop-top-subscribe-reviewsEach"> 
                                           <img src={e?.By.profile?.fileUrl} width={30} height={30} style={{borderRadius:"50%",objectFit:"cover"}}/>
                                    </div>
                                )
                             })}
                             {AllReviews.length>0&&<div className="each-shop-top-subscribe-reviewsAll-seemore"> <Button onClick={()=>GetSeeDetailsPage(!seeDetailsPage)}>See Details {AllReviews.length}</Button></div>}
                            {AllReviews.length===0&&<div>No Reviews Added</div>}
                        </div>

                      {(userAlreadyeviewd?.length===0&&routes[2]!==propsData.currentShope&&showAddReview)&&
                            <div className="each-shop-top-subscribe-reviewsAdd">
                              
                                <div  className="each-shop-top-subscribe-reviewsAdd-text">
                                    <div className="each-shop-top-subscribe-reviewsAdd-input">
                                        <TextArea   
                                        autoFocus={true}
                                            autoSize={{
                                            minRows:1,
                                            maxRows: 2,
                                            }} placeholder='Review'
                                            value={reviewText}  onChange={(e)=>handleReviewText(e.target.value)}/>

                                    </div>
                                    {reviewText.length>0&&<div>{loading?<CircularProgress size={20}/>:<Button onClick={AddReviews}>Submit</Button>}</div>}
                                </div>
                              {reviewText.length>0&&<div className="each-shop-top-subscribe-reviewsAdd-rate"> 
                                    <Rating
                                            name="simple-controlled"
                                            value={reviewRate}
                                            onChange={(event, newValue) => {
                                                handleReviewRate(newValue);
                                            }}
                                        />
                                </div> }
                                {error&&<div style={{color:"red",fontSize:"12px"}}>{error}</div>}
                            </div>
                        }
                        {(userAlreadyeviewd?.length===0&&!showAddReview&&routes[2]!==propsData.currentShope)&&<div><IconButton onClick={()=>handleShowAddReview(!showAddReview)}><RateReviewIcon style={{color:"rgba(255,115,15,1)"}}/></IconButton></div>}                     
                    </div>
                  
                  {seeDetailsPage&&<GetAllReviewsData GetSeeDetailsPage={GetSeeDetailsPage} seeDetailsPage={seeDetailsPage} route={routes[2]} propsData={propsData}/>
                    }
           </div>
         
           {propsData.currentShope!==routes[2] &&<div className="each-shop-make-chat">
               {loadingCreateChat?
                  <CircularProgress size={13}/>:
                  <IconButton onClick={creatChatAndRedirect}><ChatIcon style={{fontSize:"30px",color:"white"}}/></IconButton> 
                 }
            </div>}
            
            {amContributor&&<div className={`each-shop-invitation-text`}>
                 You are invited to this shop as admin by the owner
                 <div className={`each-shop-invitation-text-leave`}><Button onClick={()=>setLeavePage(!leavePage)}>leave Shop</Button></div>
            </div>}
            
            {(leavePage&&amContributor)&&
              <div className="each-shop-leave-page">
                <motion.div 
                initial={{opacity:0,scale:0}}
                whileInView={{opacity:1,scale:1}}
                className="each-shop-leave-page-box">
                    <div>If you live this shop, you won't access what admins access on this shop.</div>
                    <div style={{fontSize:"13px",marginTop:"8px"}}>Do you want to leave this shop ?</div>
                    <div className="each-shop-leave-page-buttons">
                       {isLeaving?
                          <CircularProgress size={30}/>
                        :
                        <>
                            <div  className="each-shop-leave-page-buttons-cancel"><Button  onClick={()=>setLeavePage(!leavePage)}>Cancel</Button></div>
                            <div  className="each-shop-leave-page-buttons-leave"><Button onClick={LeaveShop}>Leave</Button></div>
                        </>}
                    </div>
                    {errorLeaving&&<div style={{color:"red",textAlign:"center",fontSize:"13.8px"}}>{errorLeaving} </div>}
                </motion.div>
              </div>
            }

            <div className={`each-shop-nav-buttons`}>
                {
                    EachShopArray.map((item, index) => {
                        
                        return <EachLink  key={index} current={routes[2]} item={item} />
                            
                        
                    })
                }
            </div>
            
            <Outlet />
        </div>
    )
}


const GetAllReviewsData=({propsData,route,GetSeeDetailsPage,seeDetailsPage})=>{
    
    let [AllReviews,GetAllReviews]=useState([])
    let [LoadReview,HandleLoadReview]=useState(false)
   // //console.log(route);

    useEffect(()=>{
      HandleLoadReview(true)
      axios.get(`${process.env.REACT_APP_URL}/api/shope/GetShopeReviews/${route}`, //proxy uri
      {
         headers: {
            authorization:`Bearer ${ propsData.userData?.token }`,
            'Content-Type': 'application/json'
         } 
      })

      .then(res=>{
        //console.log(res.data);
        HandleLoadReview(false)
        GetAllReviews(res.data.reviews)
    
      })
      .catch(error=>{
         //console.log(error);
      })
    },[propsData.equilizer])


    let [makeEdit,hanldeMakeEdit]=useState(false)
    console.log(AllReviews);
    return(
    <div className="reviews-container">
        <div className="reviews-body">
             <div><IconButton onClick={()=>GetSeeDetailsPage(!seeDetailsPage)}><CloseIcon style={{color:"red"}}/></IconButton></div>
            <h2>Reviews</h2>
            <div  className="reviews-body-All">
                {
                    LoadReview?
                     <div style={{textAlign:"center",marginTop:"78px"}}><CircularProgress/></div>
                     :
                     <>
                        {AllReviews?.map(e=>{
                            if(!e?.By?._id){
                                return
                          }
                            return <EachReviews route={route} e={e} propsData={propsData} key={e?._id}/>
                        })}
                     
                     </>
                }
            </div>

        </div>
   </div>)
}

const EachReviews=({propsData,e,route})=>{
   /// console.log(e);
    let [makeEdit,hanldeMakeEdit]=useState(false)
    let [reviewText,handleReviewText]=useState(e?.text)
    const [reviewRate,handleReviewRate]=useState(e?.rate)

    let [loading,setLoading]=useState(false)
    let [error,GetError]=useState(false)

 //   //console.log(propsData.currentShope,e.By._id);
   const updateReview=()=>{
    setLoading(true)
    if(reviewRate===null){
        return;
    }
    let value={
        reviewId:e?._id,
        reviewer:propsData.currentShope,
        text:reviewText,
        rate:reviewRate,
    }  

    axios.put(`${process.env.REACT_APP_URL}/api/shope/UpdateReview`,value, //proxy uri
        {
        headers: {
            authorization:`Bearer ${ propsData.userData?.token }`,
            'Content-Type': 'application/json'
        } 
        })
    .then(res=>{
      //console.log(res.data);
      setLoading(false)
      hanldeMakeEdit(false)
     // propsData.setEquilizer(propsData.equilizer+3)
    })
    .catch(error=>{
        setLoading(false)
        GetError("Try, again later")
        setTimeout(()=>{
            GetError("") 
        },3000)
      //console.log(error);

    })
   }

    return(
                <div className={`reviews-body-each ${propsData.currentShope===e.By._id?.toString()&&"reviews-body-each-mine"}`}>
                   <a style={{textDecoration:"none",color:"inherit"}} to={`/shop/${e.By._id}`}>
                        <div className="reviews-body-each-profile">
                            <div><img src={e?.By?.profile?.fileUrl}  style={{borderRadius:"50%",objectFit:"cover"}} width={60} height={60}/></div>
                            <div>{e.By.shope_name}</div>
                        </div>
                    </a>
                    <div className="reviews-body-each-review">
                        <div className="reviews-body-each-review-rate">
                        <Rating name={makeEdit?"simple-controlled":"read-only"}
                            value={reviewRate}
                            onChange={(event, newValue) => {
                                handleReviewRate(newValue);
                            }}
                            readOnly={!makeEdit}
                            />
                        </div>
                        <div className="reviews-body-each-review-text">
                        {makeEdit? 
                            <TextArea   
                                autoFocus={true}
                                    autoSize={{
                                    minRows:1,
                                    maxRows: 2,
                                    }} placeholder='Review'
                                    value={reviewText}  onChange={(e)=>handleReviewText(e.target.value)}/>
                            :
                            <div>{reviewText}</div>
                            }

                        </div>
                    </div>

                    {propsData?.currentShope===e?.By?._id?.toString()&&<div>
                        {makeEdit?
                        <>
                            {loading?
                            <div style={{textAlign:"center",marginTop:"20px"}}><CircularProgress size={23}/></div>
                            :
                            <div className="reviews-body-each-review-update">
                                <div><Button onClick={updateReview}>Update</Button></div>
                                <div><Button onClick={()=>hanldeMakeEdit(!makeEdit)}>Cancel</Button></div>
                            </div>
                            }
                        </> 
                            :
                            <div style={{textAlign:"end"}}><IconButton onClick={()=>hanldeMakeEdit(!makeEdit)}><EditIcon/></IconButton> </div>}
                    
                    </div>}
            </div>
    )
}

const EachLink=({item,current})=>{

    const location = useLocation();
    const [routes, setRoutes] = useState(location.pathname.split('/'));
    const [active, setActive] = useState(item.route === routes[2]);
  
   // //console.log(routes,active,current);
    useEffect(() => {
        let currntRoute=location.pathname.split('/')
        if(currntRoute.length===3&&item.id===""){
            setActive(current === currntRoute[2]);
        }
        else{
            setActive(item.id === currntRoute[3]);

        }
    }, [location, routes]);
  
    return (
        <div>
            <NavLink to={`${item.id}`}  >
                <button className={active  ? "each-shop-nav-button each-shop-nav-button-Active" : "each-shop-nav-button"}>{item.name}</button>
            </NavLink> 
        </div>
    )

}
